module.exports = __webpack_public_path__ + "img/game2.3.5490b670.png";